export default __webpack_public_path__ + "locales/bg/Files.json?hash=971f6dfd4729f42e90dc1cba06d65da6";